/**
 * audio-tap.v1 cizici — ses akisi dinlerken hedef kelimeyi her duydugunda DOKUN.
 *
 * "İşitsel Dikkat": ses meyve adlarini sirayla okur; cocuk "Elma"yi her duydugunda
 * butona dokunur. Cevap = dokunma sayisi. Izgara cocuga GOSTERILMEZ (isitsel).
 *
 * Icerik: { prompt:{text,audioUrl}, target?, targetWord? }
 * Cevap:  onAnswerChange({ taps }); ses baslamadan null (ileri kapali).
 * Skorlama SUNUCUDA: taps == target (toleransli olabilir).
 */
import { useEffect, useRef, useState } from "react";
import type { MechanicProps } from "./types";

interface ATContent {
  prompt?: { text?: string; audioUrl?: string };
  target?: number;
  targetWord?: string;
}

/** Dokun butonundaki elma (emoji yerine; her cihazda aynı görünür). */
function AppleIcon() {
  return (
    <svg className="tap-apple" viewBox="0 0 100 100" aria-hidden="true">
      <path d="M50 30 C 47 20, 44 14, 40 10" stroke="#6b3e1f" strokeWidth="5" strokeLinecap="round" fill="none" />
      <path d="M52 24 C 60 10, 76 8, 84 14 C 76 26, 62 30, 52 24 Z" fill="#43a33b" />
      <path d="M52 24 C 62 20, 72 16, 82 14" stroke="#2e7d32" strokeWidth="2" fill="none" />
      <path d="M50 32 C 38 22, 14 24, 12 50 C 10 74, 28 94, 42 92 C 46 91, 48 89, 50 89 C 52 89, 54 91, 58 92 C 72 94, 90 74, 88 50 C 86 24, 62 22, 50 32 Z" fill="#e53935" />
      <path d="M50 32 C 62 22, 86 24, 88 50 C 90 74, 72 94, 58 92 C 70 84, 80 66, 76 46 C 72 34, 62 30, 50 32 Z" fill="#c62828" opacity="0.55" />
      <ellipse cx="30" cy="46" rx="7" ry="12" fill="#fff" opacity="0.45" transform="rotate(20 30 46)" />
    </svg>
  );
}

export function AudioTapItem({ item, onAnswerChange }: MechanicProps) {
  const c = item.content as unknown as ATContent;
  const audioUrl = c.prompt?.audioUrl;
  // ready ("Hazır mısın?" + Başla) -> playing -> done. Ses ve dokunma Başla'ya basınca başlar;
  // akış çocuk hazır olmadan başlamaz.
  const [state, setState] = useState<"ready" | "playing" | "done">("ready");
  const [taps, setTaps] = useState(0);
  const audio = useRef<HTMLAudioElement | null>(null);

  const cb = useRef(onAnswerChange);
  cb.current = onAnswerChange;
  useEffect(() => {
    if (state === "ready") cb.current(null);
    else cb.current({ taps });
  }, [taps, state]);

  function start() {
    const a = audio.current;
    if (a) {
      a.currentTime = 0;
      void a.play();
    }
    setState("playing");
  }

  return (
    <div className="mech audiotap-mech">
      {c.prompt?.text && <h2 className="prompt">{c.prompt.text}</h2>}
      <hr className="q-divider" />

      {state === "ready" ? (
        <div className="center-action">
          <p className="tap-ready">Hazır mısın?</p>
          <button type="button" className="big-action-btn" onClick={start}>
            ▶ Başla
          </button>
        </div>
      ) : (
        <div className="center-action">
          <button type="button" className="tap-btn" onClick={() => setTaps((t) => t + 1)}>
            <AppleIcon />
            <span className="tap-label">Dokun</span>
          </button>
          <div className="tap-count">
            Dokunma sayısı: <b>{taps}</b>
          </div>
          {state === "playing" ? (
            <div className="tap-playing">🔊 ses çalıyor…</div>
          ) : (
            <div className="tap-hint">Ses bitti. İlerleyebilirsin.</div>
          )}
        </div>
      )}

      <audio
        ref={audio}
        src={audioUrl}
        preload="auto"
        onEnded={() => setState("done")}
      />
    </div>
  );
}
